module.exports = __webpack_public_path__ + "img/bg_ghost_18@3x.84daa4a8.png";